// extracted by mini-css-extract-plugin
export var p = "ZubehoerReference-module--p--2MGsa";
export var title = "ZubehoerReference-module--title--1Crm9";
export var productWrapper = "ZubehoerReference-module--product-wrapper--1RF4i";